import React from "react";

import type { LegalSection } from "./legal.types";
import LegalPageLayout from "./LegalPageLayout";

const intro = ["p1"] as const;

/** Section order and shape; the prose lives under `rightsPolicy` in the legal namespace. */
const sections: LegalSection[] = [
	{ key: "whatYouMayPublish", paragraphs: ["p1", "p2"] },
	{ key: "namesAndTitles", paragraphs: ["p1"] },
	{ key: "imagesAndFiles", paragraphs: ["p1"] },
	{
		key: "howToReport",
		paragraphs: ["p1"],
		listItems: ["i1", "i2", "i3", "i4", "i5"],
		trailingParagraphs: ["p2"]
	},
	{ key: "whatHappens", paragraphs: ["p1", "p2", "p3"] },
	{ key: "contacts", paragraphs: ["p1", "p2", "p3"] }
];

const RightsPolicyPage = () => {
	return <LegalPageLayout intro={intro} page="rightsPolicy" sections={sections} />;
};

export default RightsPolicyPage;
